import io from 'socket.io-client'

// https://www.npmjs.com/package/vue-socket.io-extended
export default io(process.env.VUE_APP_SOCKET_ADDRESS, {
  autoConnect: false
})
